import { Navigate, useParams } from 'react-router-dom'

import { paths } from 'src/router'

const OPEN_CREATE_STATE = { openWorkspaceAppCreate: true as const }

/** `/apps/new` → apps index with create modal opened (plan: replace placeholder). */
export const WorkspaceAppsNewRedirect = () => {
  const { id = '' } = useParams<{ id: string }>()

  if (!id || id === 'new') {
    return <Navigate to={paths.workspaces.root} replace />
  }

  return (
    <Navigate
      to={paths.workspaces.apps.root(id)}
      replace
      state={OPEN_CREATE_STATE}
    />
  )
}
